import { render, staticRenderFns } from "./SelectClient.vue?vue&type=template&id=b35dcfa4&scoped=true"
import script from "./SelectClient.vue?vue&type=script&lang=js"
export * from "./SelectClient.vue?vue&type=script&lang=js"
import style0 from "./SelectClient.vue?vue&type=style&index=0&id=b35dcfa4&prod&scoped=true&lang=css"
import style1 from "./SelectClient.vue?vue&type=style&index=1&id=b35dcfa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35dcfa4",
  null
  
)

export default component.exports